<template>
  <div v-if="shouldShowSelector" class="reserva-servicios-seleccion mb-10">
    <div
      class="header-card header-container mb-10 d-flex justify-content-between align-items-center"
      :class="{ 'container-imagen-fondo': imagenFondoCss }"
      @click="toggleHeaderCollapse">
      <div class="header-content d-flex align-items-center">
        <img
          v-if="agrupacionServicios.icono"
          height="36"
          :src="agrupacionServicios.icono"
          :alt="agrupacionServicios.nombre"
          class="me-2 agrupacion-icon" />
        <CustomIcon v-else :icon="serviciosMetaData.icono" class="me-2 text-primary" size="36px" />
        <span class="text-primary fw-semibold fs-19 translate">{{ agrupacionServicios.nombre }}</span>
        <InfoIcon
          v-if="hasNominalServicios"
          class="custom-svgInfo"
          size="12px"
          :message-info="t('servicios.tooltipMessageIsNominal')" />
      </div>
      <CustomIcon :icon="headerCollapsed ? arrowDownIcon : arrowUpIcon" size="24px" class="text-primary" />
    </div>

    <div v-if="!headerCollapsed">
      <div>
        <div v-for="grupo in serviciosAgrupados" :key="grupo.id" class="grupo-firstfilter">
          <div v-if="grupo.name" class="grupo-titulo-header grupo-header mb-10" @click="toggleGrupoCollapse(grupo.id)">
            <div class="grupo-header-content d-flex align-items-center justify-content-between">
              <span class="text-primary fw-semibold fs-14">{{ grupo.name }}</span>
              <CustomIcon
                :icon="isGrupoCollapsed(grupo.id) ? arrowDownIcon : arrowUpIcon"
                size="24px"
                class="text-primary" />
            </div>
          </div>
          <template v-if="!isGrupoCollapsed(grupo.id)">
            <div v-for="servicio in grupo.servicios" :key="servicio.id" class="mb-2 mb-mobile-5">
              <div
                class="servicio-card"
                :class="getServicioClasses(servicio)"
                :data-bs-toggle="disabledAllServicios || isAgrupacionServiciosDisabled() ? 'tooltip' : null"
                :data-bs-title="disabledAllServicios ? $t('servicios.faltaFechaNacimiento') : null"
                :data-bs-placement="'top'"
                @click="selectServicio(servicio)">
                <div
                  class="servicio-card-content servicio-main-content d-flex justify-content-between align-items-center">
                  <div class="servicio-content flex-grow-1">
                    <div class="servicio-info-mobile servicio-info-container d-flex align-items-center flex-wrap">
                      <!-- Desktop -->
                      <div class="servicio-title-row d-md-flex d-none">
                        <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                          {{ getServicioName(servicio) }}
                        </span>
                        <span v-if="!servicio.nulo" class="servicio-fechas fs-13">
                          ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                          {{ formatDateDDmm(servicio.fechaFin) }})
                        </span>
                        <a
                          v-if="servicio.infoExtra"
                          href="#"
                          class="info-extra-link fs-13 text-decoration-underline"
                          data-bs-toggle="modal"
                          :data-bs-target="`#infoExtraModal${servicio.id}`"
                          @click.prevent.stop>
                          + {{ $t('general.info') }}
                        </a>
                      </div>

                      <!-- Mobile -->
                      <div class="d-md-none w-100">
                        <div class="d-flex align-items-center gap-2 mb-1">
                          <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                            {{ getServicioName(servicio) }}
                          </span>
                          <a
                            v-if="servicio.infoExtra"
                            href="#"
                            class="info-extra-link fs-13 text-decoration-underline"
                            data-bs-toggle="modal"
                            :data-bs-target="`#infoExtraModal${servicio.id}`"
                            @click.prevent.stop>
                            + {{ $t('general.info') }}
                          </a>
                        </div>

                        <div v-if="!servicio.nulo" class="servicio-fechas fs-13 mb-1">
                          ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                          {{ formatDateDDmm(servicio.fechaFin) }})
                        </div>
                      </div>
                    </div>
                    <!-- Mobile -->
                    <div
                      v-if="servicio.descripcion"
                      class="servicio-descripcion fs-13 d-md-none text-primary translate">
                      {{ servicio.descripcion }}
                    </div>

                    <!-- Desktop -->
                    <div
                      v-if="servicio.descripcion"
                      class="servicio-descripcion fs-13 mt-1 d-none d-md-block text-primary translate">
                      {{ servicio.descripcion }}
                    </div>

                    <a
                      v-if="isSelected(servicio) && !servicio.nulo && agrupacionServicios.tipo === SEGURO_SELECTOR"
                      href="#"
                      class="info-extra-link fs-13 text-decoration-underline mt-1"
                      @click.stop="showInsurancePolicy(servicio.id)">
                      {{ $t('servicios.seguro.verPoliza') }}
                    </a>
                  </div>

                  <div class="servicio-right-section d-flex align-items-center">
                    <!-- Desktop -->
                    <div
                      v-if="isSelected(servicio) && !servicio.nominal && selectedServicioWithCantidad"
                      class="cantidad-control me-3 d-none d-md-block"
                      @click.stop>
                      <InputSelectorCantidad
                        :disabled="!isServicioContratable(reserva, selectedServicioWithCantidad.servicio)"
                        :count="selectedServicioWithCantidad.cantidad"
                        :min-count="
                          isServicioDescontratable(reserva, selectedServicioWithCantidad.servicio)
                            ? 1
                            : selectedServicioWithCantidad.cantidadOriginal
                        "
                        :max-count="calculaMaxCantidadForServicio(selectedServicioWithCantidad.servicio)"
                        :real-max-count="calculaMaxRealCantidadForServicio(selectedServicioWithCantidad.servicio)"
                        :is-agotado="!isSelectable(selectedServicioWithCantidad.servicio)"
                        @update-count="updateCantidad" />
                    </div>

                    <div class="servicio-precio-estado">
                      <template v-if="!isSelectable(servicio)">
                        <span class="badge bg-danger fs-13">{{ $t('general.agotado') }}</span>
                      </template>
                      <template v-else>
                        <div class="precio-estado-container d-flex align-items-center">
                          <template v-if="servicio.paqueteBasico && isSelected(servicio)">
                            <span class="text-primary me-2 fs-13">{{ $t('general.incluido') }}</span>
                          </template>
                          <template v-else>
                            <span class="text-primary fs-16 fw-semibold me-2">
                              <template v-if="servicio.precio > 0">+</template>
                              <span>{{ servicio.precio }}{{ agenciaStore.getCurrency }}</span>
                            </span>
                          </template>
                          <div
                            v-if="isSelected(servicio)"
                            class="check-circle d-flex align-items-center justify-content-center">
                            <i class="fa-solid fa-check"></i>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- Mobile -->
                <div
                  v-if="isSelected(servicio) && !servicio.nominal && selectedServicioWithCantidad"
                  class="cantidad-control-mobile cantidad-container-mobile d-block d-md-none d-flex justify-content-end"
                  @click.stop>
                  <InputSelectorCantidad
                    :disabled="!isServicioContratable(reserva, selectedServicioWithCantidad.servicio)"
                    :count="selectedServicioWithCantidad.cantidad"
                    :min-count="
                      isServicioDescontratable(reserva, selectedServicioWithCantidad.servicio)
                        ? 1
                        : selectedServicioWithCantidad.cantidadOriginal
                    "
                    :max-count="calculaMaxCantidadForServicio(selectedServicioWithCantidad.servicio)"
                    :real-max-count="calculaMaxRealCantidadForServicio(selectedServicioWithCantidad.servicio)"
                    :is-agotado="!isSelectable(selectedServicioWithCantidad.servicio)"
                    @update-count="updateCantidad" />
                </div>
              </div>
            </div>
          </template>
        </div>

        <div v-for="servicio in serviciosSinAgrupar" :key="servicio.id" class="mb-2 mb-mobile-5">
          <div
            class="servicio-card"
            :class="getServicioClasses(servicio)"
            :data-bs-toggle="disabledAllServicios ? 'tooltip' : null"
            :data-bs-title="disabledAllServicios ? $t('servicios.faltaFechaNacimiento') : null"
            :data-bs-placement="'top'"
            @click="selectServicio(servicio)">
            <div class="servicio-card-content servicio-main-content d-flex justify-content-between align-items-center">
              <div class="servicio-content flex-grow-1">
                <div class="servicio-info-mobile servicio-info-container d-flex align-items-center flex-wrap">
                  <!-- Desktop -->
                  <div class="servicio-title-row d-md-flex d-none">
                    <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                      {{ getServicioName(servicio) }}
                    </span>
                    <span v-if="!servicio.nulo" class="servicio-fechas fs-13">
                      ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                      {{ formatDateDDmm(servicio.fechaFin) }})
                    </span>
                    <a
                      v-if="servicio.infoExtra"
                      href="#"
                      class="info-extra-link fs-13 text-decoration-underline"
                      data-bs-toggle="modal"
                      :data-bs-target="`#infoExtraModal${servicio.id}`"
                      @click.stop>
                      + {{ $t('general.info') }}
                    </a>
                  </div>

                  <!-- Mobile -->
                  <div class="d-md-none w-100">
                    <div class="d-flex align-items-center gap-2 mb-1">
                      <span class="text-primary translate fs-16" :class="{ 'fw-semibold': isSelected(servicio) }">
                        {{ getServicioName(servicio) }}
                      </span>
                      <a
                        v-if="servicio.infoExtra"
                        href="#"
                        class="info-extra-link fs-13 text-decoration-underline"
                        data-bs-toggle="modal"
                        :data-bs-target="`#infoExtraModal${servicio.id}`"
                        @click.stop>
                        + {{ $t('general.info') }}
                      </a>
                    </div>

                    <div v-if="!servicio.nulo" class="servicio-fechas fs-13 mb-1">
                      ({{ $t('general.del') }} {{ formatDateDDmm(servicio.fechaInicio) }} {{ $t('general.al') }}
                      {{ formatDateDDmm(servicio.fechaFin) }})
                    </div>
                  </div>
                </div>
                <!-- Mobile -->
                <div v-if="servicio.descripcion" class="servicio-descripcion fs-13 d-md-none text-primary translate">
                  {{ servicio.descripcion }}
                </div>

                <!-- Desktop -->
                <div
                  v-if="servicio.descripcion"
                  class="servicio-descripcion fs-13 mt-1 d-none d-md-block text-primary translate">
                  {{ servicio.descripcion }}
                </div>

                <a
                  v-if="isSelected(servicio) && !servicio.nulo && agrupacionServicios.tipo === SEGURO_SELECTOR"
                  href="#"
                  class="info-extra-link fs-13 text-decoration-underline mt-1"
                  @click.stop="showInsurancePolicy(servicio.id)">
                  {{ $t('servicios.seguro.verPoliza') }}
                </a>
              </div>

              <div class="servicio-right-section d-flex align-items-center">
                <!-- Desktop -->
                <div
                  v-if="isSelected(servicio) && !servicio.nominal && selectedServicioWithCantidad"
                  class="cantidad-control me-3 d-none d-md-block"
                  @click.stop>
                  <InputSelectorCantidad
                    :disabled="!isServicioContratable(reserva, selectedServicioWithCantidad.servicio)"
                    :count="selectedServicioWithCantidad.cantidad"
                    :min-count="
                      isServicioDescontratable(reserva, selectedServicioWithCantidad.servicio)
                        ? 1
                        : selectedServicioWithCantidad.cantidadOriginal
                    "
                    :max-count="calculaMaxCantidadForServicio(selectedServicioWithCantidad.servicio)"
                    :real-max-count="calculaMaxRealCantidadForServicio(selectedServicioWithCantidad.servicio)"
                    :is-agotado="!isSelectable(selectedServicioWithCantidad.servicio)"
                    @update-count="updateCantidad" />
                </div>

                <div class="servicio-precio-estado">
                  <template v-if="!isSelectable(servicio)">
                    <span class="badge bg-danger fs-13">{{ $t('general.agotado') }}</span>
                  </template>
                  <template v-else>
                    <div class="precio-estado-container d-flex align-items-center">
                      <template v-if="servicio.paqueteBasico && isSelected(servicio)">
                        <span class="text-primary me-2 fs-13">{{ $t('general.incluido') }}</span>
                      </template>
                      <template v-else>
                        <span class="text-primary fs-16 fw-semibold me-2">
                          <span v-if="servicio.precio > 0">+</span>
                          <span>{{ servicio.precio }}{{ agenciaStore.getCurrency }}</span>
                        </span>
                      </template>
                      <div
                        v-if="isSelected(servicio)"
                        class="check-circle d-flex align-items-center justify-content-center">
                        <i class="fa-solid fa-check"></i>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Mobile -->
            <div
              v-if="isSelected(servicio) && !servicio.nominal && selectedServicioWithCantidad"
              class="cantidad-control-mobile cantidad-container-mobile d-block d-md-none d-flex justify-content-end"
              @click.stop>
              <InputSelectorCantidad
                :disabled="!isServicioContratable(reserva, selectedServicioWithCantidad.servicio)"
                :count="selectedServicioWithCantidad.cantidad"
                :min-count="
                  isServicioDescontratable(reserva, selectedServicioWithCantidad.servicio)
                    ? 1
                    : selectedServicioWithCantidad.cantidadOriginal
                "
                :max-count="calculaMaxCantidadForServicio(selectedServicioWithCantidad.servicio)"
                :real-max-count="calculaMaxRealCantidadForServicio(selectedServicioWithCantidad.servicio)"
                :is-agotado="!isSelectable(selectedServicioWithCantidad.servicio)"
                @update-count="updateCantidad" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-for="servicio in availableServicios" :key="`modal-${servicio.id}`">
      <InfoExtraModal
        v-if="servicio.infoExtra"
        :modal-id="`infoExtraModal${servicio.id}`"
        :title="getServicioName(servicio)"
        :content="servicio.infoExtra" />
    </template>
  </div>
</template>

<script setup>
  import { ref, computed, onBeforeMount, onMounted, reactive, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import {
    getCategoriasServiciosMetaData,
    isServicioContratable,
    isServicioDescontratable,
    isServicioValidoEdad,
  } from '@/helpers/serviciosUtils';
  import { formatDateDDmm, calcularEdad } from '@/helpers/dateUtiles';
  import { toRawDeep } from '@/helpers/reactivityUtils';
  import InfoIcon from '@/components/Icons/InfoIcon.vue';
  import InputSelectorCantidad from '@/components/inputs/InputSelectorCantidad';
  import CustomIcon from '@/components/CustomIcon.vue';
  import InfoExtraModal from '@/components/modales/InfoExtraModal.vue';
  import arrowDownIcon from '@/assets/icons/arrow_down.svg';
  import arrowUpIcon from '@/assets/icons/arrow_up.svg';
  import ViajesGrupoApiService from '@/services/api/skiandnight/ViajesGrupoApiService';
  import { SEGURO_SELECTOR } from '@/constants/selectService';
  import { Tooltip } from 'bootstrap';

  const props = defineProps({
    agrupacionServicios: { type: Object, default: null },
    idxReserva: { type: Number, default: null },
    disabledAllServicios: { type: Boolean, default: false },
  });

  const emits = defineEmits(['servicioSeleccionado']);

  const { t } = useI18n();
  const viajeId = useRoute().params.viajeId;
  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();

  const selectedServicioWithCantidad = ref(null);
  const collapsedGrupos = reactive({});
  const headerCollapsed = ref(false);
  const imagenFondoCss = computed(() =>
    props.agrupacionServicios.imagenFondo ? `url(${props.agrupacionServicios.imagenFondo})` : ''
  );

  const reserva = computed(() => storeHabitacion.getReservaByIdx(props.idxReserva));
  const hasNominalServicios = computed(() => props.agrupacionServicios.servicios.some(s => s.nominal && !s.nulo));
  const servicioPaqueteBasico = computed(() => props.agrupacionServicios.servicios.find(s => s.paqueteBasico));
  const isAgrupacionPaqueteBasico = computed(() => props.agrupacionServicios.paqueteBasico);

  const serviciosMetaData = computed(() =>
    getCategoriasServiciosMetaData().find(({ selector }) => selector === props.agrupacionServicios.tipo)
  );

  const edadUsuario = computed(() => {
    const fechaNacimiento = reserva.value?.usuario?.fechaNacimiento;
    return fechaNacimiento ? calcularEdad(fechaNacimiento) : null;
  });

  const hasAgrupacionTarifaEdad = computed(() => {
    return props.agrupacionServicios.servicios.some(s => s.tarifaEdad && !s.nulo);
  });

  const isAgrupacionDisabled = computed(() => {
    if (!hasAgrupacionTarifaEdad.value) return false;
    if (edadUsuario.value === null) return true;

    return !props.agrupacionServicios.servicios.some(servicio => {
      if (!servicio.tarifaEdad || servicio.nulo) return false;
      return isServicioValidoEdad(servicio, edadUsuario.value);
    });
  });

  const availableServicios = computed(() => {
    const servicios = props.agrupacionServicios.servicios.filter(s => !s.nulo && (s.activo || isSelected(s)));
    return servicios.sort((a, b) => a.precio - b.precio);
  });

  const serviciosAgrupados = computed(() => {
    const serviciosConFiltros = availableServicios.value.filter(s => s.firstFilter?.id);
    if (serviciosConFiltros.length === 0) {
      return [];
    }

    const grupos = {};
    serviciosConFiltros.forEach(servicio => {
      const key = servicio.firstFilter.id;
      const name = servicio.firstFilter.nombre;

      if (!grupos[key]) {
        grupos[key] = { id: key, name, servicios: [] };
      }
      grupos[key].servicios.push(servicio);
    });

    return Object.values(grupos);
  });

  const serviciosSinAgrupar = computed(() => {
    return availableServicios.value.filter(s => !s.firstFilter?.id);
  });

  const shouldShowSelector = computed(() => {
    const selectedServicio = selectedServicioWithCantidad.value?.servicio || null;
    const serviciosSelectables = props.agrupacionServicios.servicios.filter(
      s => !s.nulo && (s.activo || selectedServicio?.id === s.id)
    );
    if (serviciosSelectables.length === 1) {
      const servicio = serviciosSelectables[0];
      if (servicio.paqueteBasico && servicio.obligatorio && servicio.nominal) {
        return false;
      }
    }
    return (selectedServicio && !selectedServicio.nulo) || serviciosSelectables.length > 0;
  });

  function isSelected(servicio) {
    return selectedServicioWithCantidad.value?.servicio?.id === servicio.id;
  }

  function isSelectable(servicio) {
    return (
      isServicioContratable(reserva.value, servicio) &&
      (isSelected(servicio) || servicio.nulo || calculaMaxCantidadForServicio(servicio) > 0)
    );
  }

  function isAgrupacionServiciosDisabled() {
    return props.disabledAllServicios || isAgrupacionDisabled.value;
  }

  function getServicioClasses(servicio) {
    const disabledPorEdad = isAgrupacionServiciosDisabled();

    return {
      selected: isSelected(servicio),
      disabled: (!isSelectable(servicio) && !isSelected(servicio)) || disabledPorEdad,
      agotado: !isSelectable(servicio) && !servicio.nulo,
      'no-deselectable': isSelected(servicio) && (servicio.paqueteBasico || servicio.obligatorio),
    };
  }

  function getServicioName(servicio) {
    let name = servicio.nombre;
    if (servicio.secondFilter?.nombre) {
      name += ` (${servicio.secondFilter.nombre})`;
    }
    return name;
  }

  function toggleHeaderCollapse() {
    headerCollapsed.value = !headerCollapsed.value;
  }

  function toggleGrupoCollapse(grupoId) {
    collapsedGrupos[grupoId] = !collapsedGrupos[grupoId];
  }

  function isGrupoCollapsed(grupoId) {
    return collapsedGrupos[grupoId];
  }

  function calculaMaxRealCantidadForServicio(servicio) {
    let cantidadActual = 0;
    if (selectedServicioWithCantidad.value && selectedServicioWithCantidad.value.servicio) {
      if (servicio.cuposMetasId?.some(id => selectedServicioWithCantidad.value.servicio.cuposMetasId?.includes(id))) {
        cantidadActual = selectedServicioWithCantidad.value.cantidad;
      }
    }
    return cantidadActual + servicio.servicioOriginal.numCupos;
  }

  function calculaMaxCantidadForServicio(servicio) {
    return Math.min(calculaMaxRealCantidadForServicio(servicio), 10);
  }

  function selectServicio(servicio) {
    if (!isSelectable(servicio) || isAgrupacionServiciosDisabled(servicio)) return;

    if (isSelected(servicio)) {
      if (servicio.paqueteBasico) return;

      if (servicioPaqueteBasico.value) {
        updateSelectedServicio(servicioPaqueteBasico.value);
      } else {
        deselectAll();
      }
      return;
    }

    updateSelectedServicio(servicio);
  }

  function updateSelectedServicio(servicio) {
    const servicioToSelect = {
      ...toRawDeep(servicio),
      servicioOriginal: servicio.servicioOriginal,
      justSelected: true,
    };

    const oldServicio = selectedServicioWithCantidad.value?.servicio;
    const oldCantidad = selectedServicioWithCantidad.value?.cantidad;

    selectedServicioWithCantidad.value = {
      servicio: servicioToSelect,
      oldServicio: oldServicio,
      cantidad: 1,
      oldCantidad: 1,
      cantidadOriginal: 1,
      categoriaPaqueteBasico: isAgrupacionPaqueteBasico.value,
      servicioPB: servicioPaqueteBasico.value,
    };

    saveToStore();

    if (!servicioToSelect.nulo) {
      storeHabitacion.decrementCupoServicios(servicioToSelect);
    }
    if (oldServicio && !oldServicio.nulo) {
      storeHabitacion.incrementCupoServicios(oldServicio, oldCantidad);
    }
  }

  function deselectAll() {
    const servicio = selectedServicioWithCantidad.value?.servicio;
    const cantidad = selectedServicioWithCantidad.value?.cantidad;
    const servicioNulo = props.agrupacionServicios.servicios.find(s => s.nulo);

    if (servicioNulo) {
      updateSelectedServicio(servicioNulo);
    } else {
      if (servicio && !servicio.nulo) {
        storeHabitacion.incrementCupoServicios(servicio, cantidad);
      }
      selectedServicioWithCantidad.value = null;

      if (reserva.value?.serviciosWithCantidad) {
        delete reserva.value.serviciosWithCantidad[props.agrupacionServicios.id];
        emits('servicioSeleccionado', props.idxReserva, props.agrupacionServicios.id, null);
      }
    }
  }

  function updateCantidad(newCantidad) {
    if (!selectedServicioWithCantidad.value) return;

    selectedServicioWithCantidad.value.cantidad = newCantidad;
    saveToStore();

    if (selectedServicioWithCantidad.value.cantidad < selectedServicioWithCantidad.value.oldCantidad) {
      storeHabitacion.incrementCupoServicios(selectedServicioWithCantidad.value.servicio);
    } else {
      storeHabitacion.decrementCupoServicios(selectedServicioWithCantidad.value.servicio);
    }
    selectedServicioWithCantidad.value.oldCantidad = newCantidad;
  }

  function saveToStore() {
    if (!selectedServicioWithCantidad.value) return;

    storeHabitacion.addServicioToReserva(
      props.idxReserva,
      selectedServicioWithCantidad.value.servicio,
      selectedServicioWithCantidad.value.cantidad
    );
    emits('servicioSeleccionado', selectedServicioWithCantidad.value);
  }

  function showInsurancePolicy(servicioId) {
    const newWindow = window.open();
    ViajesGrupoApiService.getPolizaSeguroViaje(viajeId, servicioId).then(res => {
      const file = new Blob([res], { type: 'application/pdf' });
      newWindow.location = URL.createObjectURL(file);
    });
  }

  function getServicioForAutoselect() {
    if (!isAgrupacionPaqueteBasico.value || !servicioPaqueteBasico.value) {
      return null;
    }

    if (!hasAgrupacionTarifaEdad.value) {
      return servicioPaqueteBasico.value.servicioOriginal.numCupos > 0 ? servicioPaqueteBasico.value : null;
    }

    if (servicioPaqueteBasico.value.servicioOriginal.numCupos > 0) {
      return servicioPaqueteBasico.value;
    }

    const alternativaValida = props.agrupacionServicios.servicios
      .filter(s => !s.nulo && s.activo && s.servicioOriginal.numCupos > 0)
      .sort((a, b) => a.precio - b.precio)[0];

    return alternativaValida || null;
  }

  function init() {
    const existingServicioWithCantidad = reserva.value?.serviciosWithCantidad[props.agrupacionServicios.id];
    // If the booking does not have any service of this category needs to be initialised
    if (!existingServicioWithCantidad) {
      let servicio = getServicioForAutoselect();

      if (!servicio) {
        servicio = props.agrupacionServicios.servicios.find(s => s.nulo) || null;
      }

      if (servicio) {
        selectedServicioWithCantidad.value = {
          servicio: servicio,
          oldServicio: servicio,
          cantidad: 1,
          oldCantidad: 1,
          cantidadOriginal: 1,
          categoriaPaqueteBasico: isAgrupacionPaqueteBasico.value,
          servicioPB: servicioPaqueteBasico.value,
        };
        storeHabitacion.decrementCupoServicios(servicio);
        saveToStore();
      }
    } else {
      selectedServicioWithCantidad.value = {
        servicio: existingServicioWithCantidad.servicio,
        oldServicio: existingServicioWithCantidad.servicio,
        cantidad: existingServicioWithCantidad.cantidad,
        oldCantidad: existingServicioWithCantidad.cantidad,
        cantidadOriginal: existingServicioWithCantidad.cantidad,
        categoriaPaqueteBasico: isAgrupacionPaqueteBasico.value,
        servicioPB: servicioPaqueteBasico.value,
      };
      saveToStore();
    }
  }

  onBeforeMount(() => {
    init();
  });

  watch(edadUsuario, (newEdad, oldEdad) => {
    const currentServicio = selectedServicioWithCantidad.value?.servicio;
    if (
      newEdad === oldEdad ||
      !currentServicio ||
      currentServicio.nulo ||
      (!currentServicio.tarifaEdad && !hasAgrupacionTarifaEdad.value)
    ) {
      return;
    }
    if (isAgrupacionPaqueteBasico.value) {
      const servicioParaEdad = getServicioForAutoselect();
      if (servicioParaEdad) {
        updateSelectedServicio(servicioParaEdad);
      }
    } else {
      updateSelectedServicio(props.agrupacionServicios.servicios.find(s => s.nulo));
    }
  });

  function initTooltips() {
    const tooltipTriggerList = document.querySelectorAll('.servicio-card[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].forEach(tooltipTriggerEl => {
      new Tooltip(tooltipTriggerEl, {
        trigger: 'hover',
      });
    });
  }

  function destroyAllTooltips() {
    const allCards = document.querySelectorAll('.servicio-card');
    [...allCards].forEach(card => {
      const tooltip = Tooltip.getInstance(card);
      if (tooltip) {
        tooltip.dispose();
      }
    });
  }

  onMounted(() => {
    initTooltips();
  });

  watch(
    () => props.disabledAllServicios,
    newValue => {
      destroyAllTooltips();
      if (newValue) {
        initTooltips();
      }
    }
  );
</script>

<style lang="scss" scoped>
  .reserva-servicios-seleccion {
    .header-card {
      background-color: rgba(var(--bs-light-rgb), 1);
      border-radius: var(--bs-border-radius-lg);
      border: 1px solid rgba(var(--bs-primary-rgb), 0.1);
      padding: 16px 20px;
      border-radius: var(--bs-border-radius-lg);
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background-color: rgba(var(--bs-light-rgb), 0.8);
      }
    }

    .container-imagen-fondo {
      border: none;
      background-image: linear-gradient(
          color-mix(in srgb, white 70%, transparent),
          color-mix(in srgb, white 70%, transparent)
        ),
        v-bind('imagenFondoCss');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    .grupo-firstfilter {
      .grupo-titulo-header {
        background-color: rgba(var(--bs-light-rgb), 1);
        border-radius: var(--bs-border-radius-lg);
        padding: 12.5px 15px;
        cursor: pointer;
        transition: all 0.2s ease;
        margin-bottom: 10px;
        border: 1px solid rgba(var(--bs-primary-rgb), 0.1);

        &:hover {
          background-color: rgba(var(--bs-light-rgb), 0.8);
        }
      }
    }

    .custom-svgInfo {
      margin-left: 0.3rem;
    }

    .agrupacion-icon {
      width: 36px;
      height: 36px;
    }

    .servicio-card {
      padding: 15px;
      min-height: 63px;
      border: 1px solid #e0e0e0;
      border-radius: var(--bs-border-radius);
      cursor: pointer;
      transition: all 0.2s ease;

      .servicio-info-container {
        .servicio-title-row {
          gap: 10px;
        }
      }

      &:hover:not(.disabled) {
        border-color: var(--bs-primary);
        box-shadow: 0 2px 4px rgba(var(--bs-primary-rgb), 0.1);
      }

      &.selected {
        border-color: var(--bs-secondary);
        background-color: rgba(var(--bs-secondary-rgb), 0.1);
        border-width: 2px;
      }

      &.disabled {
        cursor: not-allowed;
        opacity: 0.6;
        background-color: #f8f9fa;
      }

      &.agotado {
        border-color: var(--bs-danger-rgb);
        background-color: rgba(var(--bs-danger-rgb), 0.05);
      }

      .servicio-content {
        .servicio-descripcion {
          line-height: 1.3;
        }
      }

      .cantidad-control {
        position: relative;
        z-index: 10;
      }

      .servicio-precio-estado {
        .check-circle {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: var(--bs-secondary);

          i {
            color: white;
            font-size: 8px;
          }
        }
      }
    }

    .servicio-fechas {
      color: rgba(var(--bs-primary-rgb), 0.8);
      line-height: unset !important;
    }

    .info-extra-link {
      color: var(--bs-primary) !important;
      line-height: unset !important;

      &:hover {
        color: var(--bs-primary) !important;
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 768px) {
    .reserva-servicios-seleccion {
      .mb-mobile-5 {
        margin-bottom: 5px !important;
      }

      .agrupacion-icon {
        width: 20px !important;
        height: 20px !important;
      }

      .servicio-card {
        padding: 20px 15px;
        .servicio-content {
          margin-right: 15px;
        }

        .cantidad-container-mobile {
          position: relative;
          z-index: 10;
        }
      }
    }
  }

  .tooltip {
    .tooltip-inner {
      background-color: var(--bs-primary) !important;
      color: white !important;
      white-space: nowrap !important;
      max-width: none !important;
    }

    .tooltip-arrow::before {
      border-top-color: var(--bs-primary) !important;
    }

    &.bs-tooltip-bottom .tooltip-arrow::before {
      border-bottom-color: var(--bs-primary) !important;
    }

    &.bs-tooltip-start .tooltip-arrow::before {
      border-left-color: var(--bs-primary) !important;
    }

    &.bs-tooltip-end .tooltip-arrow::before {
      border-right-color: var(--bs-primary) !important;
    }
  }
</style>
